import { createSlice, PayloadAction, createAction } from '@reduxjs/toolkit';
import { RootState } from './rootReducer';
import {
  AvailableLanguages,
  TranslationSliceInitialState,
  LanguageTranslations,
} from './types/translationTypes';

export const translationInitialState: TranslationSliceInitialState = {
  preferredLanguage: 'en',
  errorMessage: '',
  availableLanguages: [],
  translations: {},
};

export const translationSlice = createSlice({
  name: 'translate',
  initialState: translationInitialState,
  reducers: {
    getLanguagesRequestSuccess: (
      state,
      action: PayloadAction<AvailableLanguages[]>,
    ) => {
      state.availableLanguages = action.payload;
      state.errorMessage = '';
    },
    getLanguagesRequestError: (state, action: PayloadAction<string>) => {
      state.errorMessage = action.payload;
    },
    setPreferredLanguage: (state, action: PayloadAction<string>) => {
      state.preferredLanguage = action.payload;
      state.errorMessage = '';
    },
    updateLanguageRequestError: (state, action: PayloadAction<string>) => {
      state.errorMessage = action.payload;
    },
    setTranslations: (
      state,
      action: PayloadAction<{
        translations: LanguageTranslations;
      }>,
    ) => {
      const translations = action.payload;
      state.translations = translations;
    },
  },
});
export const updateLanguage = createAction<{
  accessToken: string;
  language: string;
}>('UPDATE_LANGUAGE');
export const getLanguages = createAction('GET_LANGUAGE_REQUEST');
export const fetchTranslationsForLanguage = createAction<string>(
  'FETCH_TRANSLATIONS_FOR_LANGUAGE',
);
export const initializeTranslations = createAction('INITIALIZE_TRANSLATIONS');

export const {
  getLanguagesRequestSuccess,
  getLanguagesRequestError,
  setPreferredLanguage,
  updateLanguageRequestError,
  setTranslations,
} = translationSlice.actions;

// selectors
export const translationSelectors = {
  selectPreferredLanguages: (state: RootState) =>
    state.translate.preferredLanguage,
  selectErrorMessage: (state: RootState) => state.translate.errorMessage,
  selectAvailableLanguages: (state: RootState) =>
    state.translate.availableLanguages,
  selectTranslations: (state: RootState) => state.translate.translations,
  selectTranslationsForLanguage: (state: RootState, language: string) =>
    state.translate.translations[language] || {},
  selectTranslationsForNamespace: (
    state: RootState,
    language: string,
    namespace: string,
  ) => state.translate.translations[language]?.[namespace] || {},
};

export default translationSlice.reducer;
